import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid2 as Grid, InputLabel, MenuItem, Select, Skeleton, Typography} from "@mui/material";
import TransactionCard from "./TransactionCard";
import { useState } from "react";
import { Transaction } from "../types";

type Props = {
  transactions: Transaction[];
  loadingTransactions: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTransaction: React.Dispatch<React.SetStateAction<Transaction | undefined>>;
}

function AllTransactionsSection(props: Props) {
  const [hideTenDollarTransactions, setHideTenDollarTransactions] = useState(true);
  const [sortedBy, setSortedBy] = useState<"Date Asc" | "Date Desc" | "Price Asc" | "Price Desc">("Date Asc");

  const transactionsToDisplay = hideTenDollarTransactions ? 
    props.transactions.filter( transaction => transaction.price > 10)
    :
    props.transactions;

  switch(sortedBy) {
    case "Date Asc":
      transactionsToDisplay.sort((a,b) => a.saleDate < b.saleDate ? -1 : 1);
      break;
    case "Date Desc":
      transactionsToDisplay.sort((a,b) => a.saleDate > b.saleDate ? -1 : 1);
      break;
    case "Price Asc":
      transactionsToDisplay.sort((a,b) => a.price < b.price ? -1 : 1);
      break;
    case "Price Desc":
      transactionsToDisplay.sort((a,b) => a.price > b.price ? -1 : 1);
      break;
  }

  return (<>
    
    <Grid container alignItems="center" spacing={2} sx={{paddingBottom: "10px", paddingTop: "10px"}}>
      <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4}}>
        <span>
          <span style={{fontSize: "20px", fontWeight: "bold"}}>All Transactions</span>
          { !props.loadingTransactions && ` - ${transactionsToDisplay.length}/${props.transactions.length} shown`}
        </span>
      </Grid>
      <FormControlLabel 
        control={
          <Checkbox 
            checked={hideTenDollarTransactions} 
            onChange={(_event, checked) => setHideTenDollarTransactions(checked)} 
          />
        }
        label="Hide <= $10" 
      />
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel>Sorted by</InputLabel>
        <Select
          value={sortedBy}
          label="Sorted by"
          onChange={(event) => {
            const newValue = event.target.value;
            //@ts-ignore
            setSortedBy(newValue);
          }}
        >
          <MenuItem value={"Date Asc"}>Date Ascending</MenuItem>
          <MenuItem value={"Date Desc"}>Date Descending</MenuItem>
          <MenuItem value={"Price Asc"}>Price Ascending</MenuItem>
          <MenuItem value={"Price Desc"}>Price Descending</MenuItem>
        </Select>
      </FormControl>         
    </Grid>
    <Grid container spacing={3}>
      {props.loadingTransactions ?
        <>
        <Grid size={{ 
          xs: 12,
          sm: 6, 
          md: 4, 
          lg: 3,
          xl: 2
        }}>
          <Skeleton variant="rectangular" width="250px" height="350px" />
        </Grid>
        <Grid size={{ 
          xs: 12,
          sm: 6, 
          md: 4, 
          lg: 3,
          xl: 2
        }}>
          <Skeleton variant="rectangular" width="250px" height="350px" />
        </Grid>
        <Grid size={{ 
          xs: 12,
          sm: 6, 
          md: 4, 
          lg: 3,
          xl: 2
        }}>
          <Skeleton variant="rectangular" width="250px" height="350px" />
        </Grid>
        </>
        :
        transactionsToDisplay.map( transaction => <Grid size={{ 
          xs: 12,
          sm: 6, 
          md: 4, 
          lg: 3,
          xl: 2
        }}>
          <TransactionCard 
              transaction={transaction} 
              setDialogOpen={props.setDialogOpen} 
              setSelectedTransaction={props.setSelectedTransaction}
          />
        </Grid>)}
    </Grid>
  </>);
}

export default AllTransactionsSection;
